import React, { useEffect, useMemo, useState } from 'react'
// import { SlEye } from 'react-icons/sl'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../../components/PadContainer'
import TitleContainer from '../../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Select, Space, Tag, Upload, notification } from 'antd'
import eventImage from '../../../../assets/gallery/event.png'
import { formatCurrency, handleConfirm, handleTableSelect, statusType } from '../../../../context/utils'
import CustomTable from '../../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit } from 'react-icons/bi'
import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useDeleteBrand } from '../../../../hooks/brands/brands'
import { useGetProducts } from '../../../../hooks/products/products'
import SearchPage from '../../../../components/searchPage'
import { useGetInsuredPackage, useGetPackage, usePostPackage, usePutPackage } from '../../../../hooks/insuredCompany/insuredCompany'

function InsuredPackage() {
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [image, setImage] = useState({})
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
//   const onViewOpen = () => setIsViewOpen(true)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onOpenEdit = () => setIsOpenEdit(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setRows([])
  }
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
  }
   
  const [createPayload, setCreatePayload] = useState({    
    name: "",
    productId: "",
    ImageFile: "",
    price: "",
    numberOfDays: "",
    percentageOff: "",
    id:"",
    // isActive:""
})

  const {
    data: getPackagesData,
    refetch: getFetch,
    isFetching: getPackageLoad,
  } = useGetInsuredPackage(    
    { pageNumber:page, searchString: search },
    ["pageNumber", "searchString"],
  )
  
const {
  data: getProductsData,
  isFetching: getProductsLoad,
} = useGetProducts()

const {
  data: getData,
  mutate: getAction,
  isLoading: getLoad,
} = useGetPackage(onOpenEdit)

  const successAction = () => {
    form.resetFields();
    onCreateClose()
    getFetch();
  };

  useEffect(() => {
    setCreatePayload({
      name: getData?.data?.name || "",
      numberOfDays: getData?.data?.numberOfDays || "",
      percentageOff: getData?.data?.percentageOff || "",
      price: getData?.data?.price || "",
      productId: getData?.data?.productIds || [],
      // productIds: getData?.data?.products?.map((e)=>(e?.id)) || [],
      ImageFile: getData?.data?.imageUrl || "",
      id: getData?.data?.id || "",
    })
    
  }, [getData?.data])

  const uploadProps = useMemo(() => ({
    name: 'file',
    method: 'GET',
    multiple: false,
    data: image?.file,
    onChange({file, fileList}) {
      setImage({
        file,
        name: file?.name,
        fileObj: file?.originFileObj,
        url: URL.createObjectURL(file?.originFileObj),
      })
      // setCreatePayload({...createPayload, ImageFile: file?.originFileObj})
    }
  }), [image]);

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostPackage(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePutPackage(successAction)

  
  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteBrand(successAction)

//   const handleView = ({target:{id}}) => {
//     onViewOpen()
//   }
  const handleEdit = (d) => {    
    // getAction(d.id)
    setCreatePayload({
      name: d?.name || "",
      numberOfDays: d?.numberOfDays || "",
      percentageOff: d?.percentageOff || "",
      price: d?.price || "",
      productId: d?.productIds || [],
      ImageFile: d?.imageUrl || "",
      id: d?.id || "",
    })  
    onOpenEdit()  
  }

  const columns = [
    {
      title: "Package Name",
      dataIndex: "name",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <Avatar src="">{e?.charAt(0)}</Avatar>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    // {
    //   title: "Status",
    //   dataIndex: "isActive", 
    //   key:"2",
    //   render: (e) => 
    //   <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    // },
    {
      title: "Price",
      dataIndex: "price",
      key:"3",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{formatCurrency(e)}</p>
      </div>,
    },
    {
      title: "Package Image",
      dataIndex: "imageUrl",
      key:"3",
      render: (e) => 
        <Image src={e} alt='vRV' width={70} />
    },
    {
      title: "Number Of Days",
      dataIndex: "numberOfDays",
      key:"numberOfDays",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Percentage Off",
      dataIndex: "percentageOff",
      key:"percentageOff",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' />Edit</button>},
          // {key: "delete", icon: <GoTrash className='!text-base mx-4 py-auto' />, label: <button onClick={() => handleConfirm({})}>Delete</button>},
          {key: "delete", label: <button onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},

        ]}}
      >
        <Button loading={getLoad || deleteLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]
const onSubmit = (d) => {
    const isActive = !d.isActive ? true : d.isActive;
    if (!image?.fileObj) {
      notification.error({
        message: "Failed!",
        description: "Please Image is Required",
      })
    }else{
      const payload = {
          isActive,
          name: d.name,
          price: d.price,
          numberOfDays: d.numberOfDays,
          ImageFile: image?.fileObj,
          productId: d.productIds,
          percentageOff: d.percentageOff
        }
        postAction(payload)
    }
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
    // console.log(createPayload)

  }

  return (
    <PadContainer loading={getPackageLoad|| getProductsLoad}>
      <TitleContainer
        path={false}
        title="Insured Package Management"
        className="border border-lit rounded-xl"
        action={<div className='flex'>
          <SearchPage setSearch={setSearch} size='large' />
          <Button onClick={onCreateOpen} className='!bg-light_blue mx-2' type='primary' size='large' icon={<FaPlus />}>Insure Package</Button>
        </div>
      }
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getPackagesData?.data?.data}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Insure New Package</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Package Name" name="name">
            <Input size='large' placeholder='Package Name' />
          </Form.Item>
          <Form.Item label="Price" name="price">
            <Input size='large' placeholder='package price' />
          </Form.Item>
          <Form.Item label="Percentage Off" name="percentageOff">
            <Input size='large' placeholder='Percentage Off' />
          </Form.Item>
          <Form.Item label="Number Of Days" name="numberOfDays">
            <Input size='large' placeholder='Number Of Days' type='number' />
          </Form.Item>
          <Form.Item label="Category" name="productIds">
            <Select size='large' placeholder='Select Categories'>              
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} loading={postLoad} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Package</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Package Name">
            <Input 
              size='large' 
              placeholder='Package Name' 
              value={createPayload.name}
              onChange={({target:{value}})=> setCreatePayload({...createPayload, name: value})}
            />
          </Form.Item>
          <Form.Item label="Price">
            <Input 
              size='large' 
              placeholder='package price' 
              value={createPayload.price}
              onChange={({target:{value}})=> setCreatePayload({...createPayload, price: value})}
            />
          </Form.Item>
          <Form.Item label="Percentage Off" name="percentageOff">
            <Input 
              size='large' 
              placeholder='Percentage Off' 
              value={createPayload.percentageOff}
              onChange={({target:{value}})=> setCreatePayload({...createPayload, percentageOff: value})}
            />
          </Form.Item>
          <Form.Item label="Number Of Days">
            <Input 
              size='large' 
              placeholder='Number Of Days' 
              type='number' 
              value={createPayload.numberOfDays}
              onChange={({target:{value}})=> setCreatePayload({...createPayload, numberOfDays: value})}
            />
          </Form.Item>
          <Form.Item label="Category" name="productIds">
            <Select 
              size='large' 
              placeholder='Select Categories'      
              value={createPayload.productId}
              onChange={(value)=> setCreatePayload({...createPayload, productId: value})}
            >              
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>          
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>            
            <Form.Item>
              <Upload {...uploadProps} listType="picture">
                <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
              </Upload>
            </Form.Item>
            <Form.Item>
              <Space size={12}>
                <Image
                  width={100}
                  src={createPayload.ImageFile}
                  placeholder={
                    <Image
                      preview={false}
                      src={createPayload.ImageFile}
                      width={200}
                    />
                  }
                />
              </Space>
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} loading={putLoad} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Brands</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Brands image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default InsuredPackage